<router-outlet></router-outlet>
<div *ngIf="!ccConsent && !isMobile && showCookie" class="cookie-consent">
  <div class="consent-text">
    {{ 'CookieText' | translate }}
    <a
      class="more-link"
      (click)="onMoreInfo(); sendUpGaEvent('cgu ml', 'Info')"
      routerLink="/about/cgu"
      fragment="cookie-policy"
      >{{ 'More' | translate }}</a
    >
  </div>
  <div class="consent-buttons">
    <button
      mat-flat-button
      class="consent-button refuse"
      (click)="ccRefused(); sendUpGaEvent('CGU', 'CGU', 'declined')"
    >
      {{ 'Refuse' | translate }}
    </button>
    <button
      mat-flat-button
      class="consent-button accept"
      (click)="ccAccepted(); sendUpGaEvent('CGU', 'CGU', 'accepted')"
    >
      {{ 'Accept' | translate }}
    </button>
    <button
      mat-button
      routerLink="/about/cgu"
      (click)="onMoreInfo(); sendUpGaEvent('cgu ml', 'Info')"
      fragment="cookie-policy"
    >
      Personnaliser<mat-icon class="east-arrow">east</mat-icon>
    </button>
  </div>
</div>

<div *ngIf="!ccConsent && isMobile && showCookie" class="cookie-consent-sp">
  <div class="consent-text-sp">
    {{ 'CookieText' | translate }}
    <a
      class="more-link"
      (click)="onMoreInfo(); sendUpGaEvent('cgu ml', 'Info')"
      routerLink="/about/cgu"
      fragment="cookie-policy"
      >{{ 'More' | translate }}</a
    >
  </div>
  <div class="consent-buttons-sp">
    <button
      mat-flat-button
      class="consent-button-sp accept"
      (click)="ccAccepted(); sendUpGaEvent('CGU', 'CGU', 'accepted')"
    >
      {{ 'Accept' | translate }}
    </button>
    <button
      mat-flat-button
      class="consent-button-sp refuse"
      (click)="ccRefused(); sendUpGaEvent('CGU', 'CGU', 'declined')"
    >
      {{ 'Refuse' | translate }}
    </button>
  </div>
</div>
